import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "@/data/site";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      data-testid="faq-section"
      className="relative py-24 md:py-32 border-t border-slate-100 bg-[#fafafa]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.24em] text-blue-600 font-semibold">/ FAQ</div>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-light tracking-tight text-slate-900 leading-[1.02]">
              Frequently<br />
              <span className="font-serif-editorial italic">asked</span>.
            </h2>
            <p className="mt-6 text-slate-600 leading-relaxed">
              Something we haven't covered? Write to us — most enquiries get a reply the same day.
            </p>
          </div>

          <div className="md:col-span-8">
            <div className="divide-y divide-slate-200">
              {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={i} data-testid={`faq-item-${i}`} className="py-2">
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      data-testid={`faq-toggle-${i}`}
                      className="w-full py-6 flex items-start justify-between gap-6 text-left group"
                      aria-expanded={isOpen}
                    >
                      <span className="font-display text-lg md:text-xl font-medium text-slate-900 group-hover:text-blue-600 transition-colors">
                        {f.q}
                      </span>
                      <span className="mt-1 flex-shrink-0 w-9 h-9 rounded-full border border-slate-200 flex items-center justify-center transition-colors group-hover:border-slate-900">
                        {isOpen
                          ? <Minus className="w-4 h-4 text-slate-900" strokeWidth={1.75} />
                          : <Plus className="w-4 h-4 text-slate-900" strokeWidth={1.75} />}
                      </span>
                    </button>
                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.4, ease: [0.2, 0.7, 0.15, 1] }}
                          className="overflow-hidden"
                        >
                          <p className="pb-8 pr-16 text-slate-600 leading-relaxed text-base md:text-lg">
                            {f.a}
                          </p>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
